module.exports = __webpack_public_path__ + "img/53.f6970ef6.jpg";